import { createAsyncThunk } from '@reduxjs/toolkit';
import { getPrivateThread } from 'store/chat/services/getPrivateThread.service';
import { loadThreadUsersThunk } from './loadThreadUsers';

export const getPrivateThreadThunk = createAsyncThunk(
  'chat/getPrivateThread',
  async (
    { userId, projectId, parentThreadId, setAsActive = true },
    { getState, dispatch }
  ) => {
    const thread = await getPrivateThread({
      userId,
      projectId,
      parentThreadId,
    });

    // Load users for this thread if it's being set as active
    if (setAsActive && thread) {
      await dispatch(loadThreadUsersThunk({ thread }));
    }

    return { thread, setAsActive };
  }
);
